import { useNavigate, useSearchParams } from "react-router-dom";
import { SimpleProjectDashboard } from "@/components/SimpleProjectDashboard";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const QuickReview = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const projectId = searchParams.get("projectId");
  const quoteId = searchParams.get("quoteId");

  if (!projectId) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center px-4">
        <Card className="max-w-lg">
          <CardHeader>
            <CardTitle>Quick Review</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <p className="text-muted-foreground">
              Provide a valid <code>projectId</code> in the URL query string to launch quick review.
            </p>
            <Button onClick={() => navigate(-1)} variant="outline">
              Go Back
            </Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <SimpleProjectDashboard projectId={projectId} quoteId={quoteId} onBack={() => navigate(-1)} />
  );
};

export default QuickReview;
